// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2WSsw","actionsCol":"EnrolledClinics_actionsCol__21Or_"};